import React, { useState } from 'react';
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footer from '../../Footers';
import './Combo.css';
import NewsletterSection from '../../NewsletterSection';
import { FaStar, FaShoppingCart, FaEye } from 'react-icons/fa';
import { useCart } from '../../cart/CartContext';
import { useNavigate } from 'react-router-dom';
import product1 from '../services-images/combo-1.webp';
import product2 from '../services-images/combo-2.webp';
import product3 from '../services-images/combo-3.webp';
import product4 from '../services-images/combo-4.webp';
import product5 from '../services-images/combo-5.webp';
import product6 from '../services-images/combo-6.webp';
import product7 from '../services-images/combo-7.webp';
import product8 from '../services-images/combo-8.webp';

const products = [
  {
    id: 1,
    title: 'Pure Shilajit Resin 50g (30g+20g) – Immunity Booster – Best Selling Combo',
    price: 499,
    originalPrice: 899,
    discount: '45% OFF',
    rating: 4.3,
    reviews: 120,
    image: product1
  },
  {
    id: 2,
    title: 'Combo Pack of Shilajit 90 Capsules & Ashwagandha 90 Capsules',
    price: 399,
    originalPrice: 799,
    discount: '50% OFF',
    rating: 4.5,
    reviews: 85,
    image: product2
  },
  {
    id: 3,
    title: 'Combo Pack of Shilajit / Shilajeet Resin 20g & Ashwagandha 90 Capsules – Boost Immunity',
    price: 599,
    originalPrice: 999,
    discount: '40% OFF',
    rating: 4.1,
    reviews: 95,
    image: product3
  },
  {
    id: 4,
    title: 'Combo Pack of Pure Shilajit Resin 20g & Safed Musli Capsules – Best Selling Combo',
    price: 699,
    originalPrice: 1199,
    discount: '42% OFF',
    rating: 4.6,
    reviews: 105,
    image: product4
  },
  {
    id: 5,
    title: 'Combo Pack of Shilajit 90 Capsules & Ashwagandha 90 Capsules',
    price: 449,
    originalPrice: 849,
    discount: '47% OFF',
    rating: 4.2,
    reviews: 77,
    image: product5
  },
  {
    id: 6,
    title: 'Combo Pack of Shilajit / Shilajeet Resin 20g and Kashmiri Kesar 1g – Best Selling Combo',
    price: 749,
    originalPrice: 1299,
    discount: '42% OFF',
    rating: 4.4,
    reviews: 98,
    image: product6
  },
  {
    id: 7,
    title: 'Combo Pack of Shilajit Resin 20g, Kesar 1g, Ashwagandha 90 Capsules',
    price: 529,
    originalPrice: 999,
    discount: '47% OFF',
    rating: 4.3,
    reviews: 63,
    image: product7
  },
  {
    id: 8,
    title: 'Combo Pack of Shilajit Resin 10g & Shilajit Effervescent Orange Flavor',
    price: 879,
    originalPrice: 1399,
    discount: '37% OFF',
    rating: 4.7,
    reviews: 132,
    image: product8
  }
];

export default function Combo() {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleBuyNow = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  const openQuickView = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const closeQuickView = () => {
    setSelectedProduct(null);
    setShowModal(false);
  };

  return (
    <div>
      <Header />
      <Navbar />

      <div className="product-list-container">
        <p className="product-count-combo">Displaying: {products.length} products</p>
        <div className="products-grid-combo">
          {products.map((product) => (
            <div className="product-card-combo" key={product.id}>
              <div className="rating">
                <FaStar className="star-icon" />
                {product.rating}/5 ({product.reviews})
              </div>
              <div className="discount">{product.discount}</div>
              <img src={product.image} alt={product.title} className="product-image-combo" />
              <h3 className="product-title">{product.title}</h3>
              <div className="price-section">
                <span className="new-price">₹{product.price}</span>
                <span className="old-price">₹{product.originalPrice}</span>
              </div>
              <div className="actions">
                <button className="buy-btn" onClick={() => handleBuyNow(product)}>
                  <FaShoppingCart className="cart-icon" /> ADD TO CART
                </button>
                <button className="quick-view-btn" onClick={() => openQuickView(product)}>
                  <FaEye />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && selectedProduct && (

        <div className="modal-overlay" onClick={closeQuickView}>
          <div className="modal-content two-column" onClick={(e) => e.stopPropagation()}>


            {/* LEFT SIDE - PRODUCT IMAGE */}
            <div className="modal-image">
              <img src={selectedProduct.image} alt={selectedProduct.title} />

            </div>

            {/* RIGHT SIDE - PRODUCT DETAILS */}
            <div className="modal-details">
              <button className="close-modal" onClick={closeQuickView}>×</button>

              <h2>{selectedProduct.title}</h2>
              <p className="price-line">
                M.R.P. <span className="old-price">₹{selectedProduct.originalPrice}</span>{' '}
                <strong>₹{selectedProduct.price}</strong>
              </p>

              <div className="product-benefits">

                <h4>Product Benefits</h4>
                <ul>
                  <li>✅ Helps to provide Physical Power</li>
                  <li>✅ Helps to regulate blood pressure</li>
                  <li>✅ Helps to drive essential nutrients to the brain</li>
                  <li>✅ Boosts Immune System</li>
                  <li>✅ Helps to reduce stress and anxiety</li>
                </ul>
              </div>

              <div className="coupon-offers">
                <h4>GET EXCITING OFFERS</h4>
                <div className="offer-cards">
                  <div className="offer-card">
                    <strong>Save 10%</strong>
                    <p>On Orders Above ₹999<br />Use Coupon - <b>SAVE10</b></p>
                  </div>
                  <div className="offer-card">
                    <strong>Save 15%</strong>
                    <p>On Orders Above ₹1599<br />Use Coupon - <b>SAVE15</b></p>
                  </div>

                </div>
              </div>

              <div className="quantity-add">
                <button className="buy-btn" onClick={() => handleBuyNow(selectedProduct)}>
                  <FaShoppingCart className="cart-icon" /> ADD TO CART
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      <NewsletterSection />
      <Footer />
    </div>
  );
}











